export default __webpack_public_path__ + "static/badge-do-2-bold-dark-0042f020f6bf86161de10b231faea03a.png";